import store from '@/store'
import _ from 'lodash'

const getItemFractions = (itemId) => {
  return store.getters['fractions/fractionItemMap'][itemId]
}

const getSelectedItemFractionTypes = (itemId) => {
  const selectedFractionTypes = store.getters['fractions/selectedFractionTypes']
  return _.filter(selectedFractionTypes, fraction => _.includes(fraction.items, itemId))
}

const getSelectedFractionTypesForItem = (key, context, productId) => {
  var returnData = ''
  const fractionTypes = getSelectedItemFractionTypes(productId)
  if(fractionTypes && fractionTypes.length > 0) {
    returnData = _.chain(fractionTypes).flatMap('contexts').filter((context) => {
      return context && context.contextId === key && context.productId === productId && context.contextName !== ''
    }).map('contextName').uniq().join().value().bold()
  } else {
    returnData = context
  }
  return returnData
}

const getSelectedFractionTypesForItemDetailsPage = (activeContexts, productId) => {
  var returnData = ''
  const fractionTypes = getSelectedItemFractionTypes(productId)
  const activeContextIds = activeContexts != null ? Object.keys(activeContexts) : ''

  if(fractionTypes && fractionTypes.length > 0) {
    // Does NOT match against productId. Different from productListing.
    returnData = _.chain(fractionTypes).flatMap('contexts').filter((context) => {
      return context && _.includes((activeContextIds), context.contextId) && context.contextName !== ''
    }).map((context) => { return context.contextName.bold() }).uniq().value()
  } else {
    returnData = _.chain(activeContexts).map((value) => { return value }).uniq().value()
  }

  // Fallback in case no returndata is matched.
  if(!returnData.length > 0 && !fractionTypes.length > 0) {
    returnData = _.chain(activeContexts).map((value) => { return value }).uniq().value()
  }

  return returnData
}

const getSelectedFractionTypesForItemProductListing = (activeContexts, productId) => {
  var returnData = ''
  const fractionTypes = getSelectedItemFractionTypes(productId)
  const activeContextIds = Object.keys(activeContexts)
  if(fractionTypes && fractionTypes.length > 0) {
    returnData = _.chain(fractionTypes).flatMap('contexts').filter((context) => {
      return context && _.includes((activeContextIds), context.contextId) && context.productId === productId && context.contextName !== ''
    }).map((context) => { return context.contextName.bold() }).uniq().value()
  } else {
    returnData = _.chain(activeContexts).map((value) => { return value }).uniq().value()
  }

  if(!returnData.length > 0 && !fractionTypes.length > 0) {
    return _.chain(activeContexts).map((value) => { return value }).uniq().value()
  }

  return returnData
}

const hasSelectedMatchingFractions = (itemId) => {
  const selectedItemFractionTypes = getSelectedItemFractionTypes(itemId)
  const allItemFractionTypes = _.get(store.getters['fractions/fractionItemMap'], [itemId], [])
  const groups = _.groupBy(allItemFractionTypes, 'fraction.fractionId')

  const matches = _.chain(groups).filter(fractionTypeGroup => {
    return _.some(fractionTypeGroup, item => _.some(selectedItemFractionTypes, item.fractionType))
  }).value()

  const allSelectionsHasItemFractionTypeMatch = _.every(store.getters['fractions/selectedFractionTypes'], ft => _.chain(allItemFractionTypes).map('fractionType').includes(ft).value())
  const matchingCount = matches.length
  const fractionCount = _.keys(groups).length

  return {
    matchesOneOfAll: fractionCount === matchingCount,
    partialMatch: matchingCount > 0 && matchingCount < fractionCount,
    noItemFractions: fractionCount === 0,
    hasMismatchSelected: fractionCount > 0 && !allSelectionsHasItemFractionTypeMatch
  }
}

export default { getSelectedItemFractionTypes, hasSelectedMatchingFractions, getItemFractions, getSelectedFractionTypesForItem, getSelectedFractionTypesForItemDetailsPage, getSelectedFractionTypesForItemProductListing }
